import { Sport } from "./Sport";
import { User } from "./User";

export interface Profile{
    userID:string;
    firstName?:string;
    lastName?:string;
    fullName?:string;
    username:string,
    image?:string;
    bio?:string;
    followersCount:number;
    followingCount:number;
    following:boolean;
    friendsCount:number;
    userStatusInGameID?:string;
    latitude: number;
    longitude: number;
    sports:Sport[];
}

export class Profile implements Profile{

    constructor(user:User)
    {
        this.username = user.userName;
        this.userID = user.userID;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.fullName = user.fullName;
        this.image = user.image;
        this.userStatusInGameID = user.userStatusInGameID;
        this.longitude = user.longitude;
        this.latitude = user.latitude;
        this.sports = user.sports;
    }

}

export interface UserGame{
    id:string;
    gameName:string;
    sportName:string;
    dateTimeStart:Date;
    hostUsername:Date;
}